export enum DocumentableType {
  ADMIN_TASK = "AdminTask",
  COMMENT = "Comment",
}
